import { storyblokEditable, renderRichText } from '@storyblok/react'
import Image from 'next/image'
import { FomaHeroStoryblok, HeroLinkStoryblok } from '@/component-types-sb'

export default function FomaHero({ blok }: { blok: FomaHeroStoryblok }) {
    const textHtml = blok.text
        ? String(renderRichText(blok.text as Parameters<typeof renderRichText>[0]) || '')
        : ''
    const logoWidth = blok.logo?.width || 1200
    const logoHeight = blok.logo?.height || 400
    const hasText = textHtml.replace(/<[^>]*>/g, '').trim().length > 0
    const hasLinks = (blok.links?.length ?? 0) > 0
    const showRight = hasText || hasLinks

    return (
        <>
            {/* HERO */}
            <section
                {...storyblokEditable(blok)}
                className="bg-primary"
            >
                <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row px-5 md:px-10 pt-16 md:pt-24 pb-4 gap-2">
                    {/* LEFT */}
                    <div className="md:w-1/2 flex flex-col justify-end bg-primary">
                        {blok.logo?.filename && (
                            <Image
                                src={blok.logo.filename}
                                alt={blok.logo.alt || ''}
                                width={logoWidth}
                                height={logoHeight}
                                sizes="(max-width: 768px) calc(100vw - 40px), 560px"
                                className="w-full h-auto object-contain animate-slide-in-left"
                                priority
                            />
                        )}
                    </div>

                    {/* RIGHT */}
                    {showRight && (
                    <div className="bg-background md:w-1/2 flex flex-col justify-between px-4 md:px-8 border-8 border-black @container animate-slide-in-right">
                        {hasText && (
                            <section
                                className="prose py-4 [&>p]:text-l md:[&>p]:text-xl"
                                dangerouslySetInnerHTML={{ __html: textHtml }}
                            />
                        )}
                        {hasLinks && (
                            <div className="w-full flex flex-wrap gap-x-8 py-2">
                                {blok.links?.map((item: HeroLinkStoryblok) => (
                                    <a
                                        key={item._uid}
                                        href={item.url?.cached_url || item.url?.url || '/'}
                                        className="font-bold hover:text-primary transition whitespace-nowrap leading-[1.4]"
                                        style={{ fontSize: 'clamp(1rem, 8cqw, 5.5rem)' }}
                                    >
                                        {item.label}
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>
                    )}
                </div>
            </section>
        </>
    )
}